import React from 'react';
import { Page, Content } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { urlConfigMap } from './config';

const useStyles = makeStyles(() => ({
  page: {
    '& article': {
      padding: 0,
      overflow: 'hidden',
    },
  },
  iframe: {
    border: 'none',
  },
}));

export type DxIFrameProps = {
  type: 'storybook' | 'system-status';
  url?: string;
};

export const DxIFrame = ({ type, url: urlOverride }: DxIFrameProps) => {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const url = urlOverride ?? configApi.getString(urlConfigMap[type]);

  if (!url) throw new Error(`${type} url cannot be empty`);

  return (
    <div className={classes.page}>
      <Page themeId="home">
        <Content>
          <iframe
            className={classes.iframe}
            height="100%"
            width="100%"
            src={url}
            title="none"
          />
        </Content>
      </Page>
    </div>
  );
};
